/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Focus_Pass_Page_TitleInputs */

const en_focus_pass_page_title = /** @type {(inputs: Focus_Pass_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autumn Focus Fest`)
};

const ar_focus_pass_page_title = /** @type {(inputs: Focus_Pass_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مهرجان الصيف للتركيز`)
};

const de_focus_pass_page_title = /** @type {(inputs: Focus_Pass_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frühjahrs-Fokusfest`)
};

const es_focus_pass_page_title = /** @type {(inputs: Focus_Pass_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Festival de concentración de verano`)
};

const fr_focus_pass_page_title = /** @type {(inputs: Focus_Pass_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'Été de la Concentration`)
};

const it_focus_pass_page_title = /** @type {(inputs: Focus_Pass_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Festa della Concentrazione Estiva`)
};

const ja_focus_pass_page_title = /** @type {(inputs: Focus_Pass_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`夏の集中フェス`)
};

const ko_focus_pass_page_title = /** @type {(inputs: Focus_Pass_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`여름 집중 축제`)
};

const pt_br_focus_pass_page_title = /** @type {(inputs: Focus_Pass_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Festival de foco do verão`)
};

const ru_focus_pass_page_title = /** @type {(inputs: Focus_Pass_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Летний фестиваль фокусировки`)
};

const th_focus_pass_page_title = /** @type {(inputs: Focus_Pass_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เทศกาลโฟกัสฤดูร้อน`)
};

const tr_focus_pass_page_title = /** @type {(inputs: Focus_Pass_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yaz Odaklanma Festivali`)
};

const zh_cn_focus_pass_page_title = /** @type {(inputs: Focus_Pass_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`夏日专注季`)
};

const zh_tw_focus_pass_page_title = /** @type {(inputs: Focus_Pass_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`秋日專注祭`)
};

/**
* | output |
* | --- |
* | "Autumn Focus Fest" |
*
* @param {Focus_Pass_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const focus_pass_page_title = /** @type {((inputs?: Focus_Pass_Page_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Focus_Pass_Page_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_focus_pass_page_title(inputs)
	if (locale === "ar") return ar_focus_pass_page_title(inputs)
	if (locale === "de") return de_focus_pass_page_title(inputs)
	if (locale === "es") return es_focus_pass_page_title(inputs)
	if (locale === "fr") return fr_focus_pass_page_title(inputs)
	if (locale === "it") return it_focus_pass_page_title(inputs)
	if (locale === "ja") return ja_focus_pass_page_title(inputs)
	if (locale === "ko") return ko_focus_pass_page_title(inputs)
	if (locale === "pt_br") return pt_br_focus_pass_page_title(inputs)
	if (locale === "ru") return ru_focus_pass_page_title(inputs)
	if (locale === "th") return th_focus_pass_page_title(inputs)
	if (locale === "tr") return tr_focus_pass_page_title(inputs)
	if (locale === "zh_cn") return zh_cn_focus_pass_page_title(inputs)
	return zh_tw_focus_pass_page_title(inputs)
});